// extracted by mini-css-extract-plugin
export var nav = "nav-module--nav--EowNC";
export var list = "nav-module--list--nDGxP";
export var item = "nav-module--item--SYoWd";
export var link = "nav-module--link--88R1V";
export var linkIsCurrent = "nav-module--link-is-current--futJT";